// extracted by mini-css-extract-plugin
export default {"container":"subHeader_container__mIlK3"};